import styled from 'styled-components'

import { KEYBOARD_ONLY_OUTLINE } from '@/ui/constants/commonStyles'
import { styleFromTypography } from '@/ui/helpers/styleFromTypography'
import { Theme } from '@/ui/theme/theme'
import { RequiredPickMap } from '@/ui/typings/helpers'

import { TextLinkProps } from '.'

const colorFromType = (theme: Theme) => ({
  primary: theme.colors.green.dark1,
  secondary: theme.colors.purple.primary,
})

type TextLinkBaseProps = RequiredPickMap<
  TextLinkProps,
  'hasUnderline' | 'size' | 'variant' | 'weight'
>

export const TextLinkBase = styled.a<TextLinkBaseProps>(
  ({ $hasUnderline, $size, $variant, $weight, theme }) => `
  ${KEYBOARD_ONLY_OUTLINE}
  ${styleFromTypography(theme.typography.body[$size])}
  
  color: ${colorFromType(theme)[$variant]};
  cursor: pointer;
  font-family: inherit;
  font-weight: ${theme.fontWeight[$weight]};
  text-decoration: ${$hasUnderline ? 'underline' : 'none'};

  &:hover,
  &:focus,
  &:active {
    text-decoration: ${$hasUnderline ? 'none' : 'underline'};
  }
`
)
